import { Injectable } from '@angular/core';
import {CanActivate, Router} from "@angular/router";
import { UserService } from '../user.service';
@Injectable({
  providedIn: 'root'
})
export class SessionAdminService implements CanActivate {
  public localData:any;
  
  constructor( 
    public router:Router,
    public usri: UserService) { 
    this.localData = localStorage.getItem('userDetails');
  }

  canActivate() {
    if (this.localData || this.usri.loggedIn) {
      return true;
    } else {
      // console.log(this.localData);
      // window.alert("User Logged Out, Please Login Again");
      this.router.navigate(["login-admin"]);
      // return false;
    }
  }

  ngOnInIt(){

  }
}
